import BarPlot from "../figures/BarPlot";
import React from "react";
import { Accordion, AccordionTab } from "primereact/accordion";
import { InputText } from "primereact/inputtext";
import { PanelMenu } from "primereact/panelmenu";
import { Button } from "primereact/button";
import axios from "axios";

export default function AnalyticsPanel({
  experiment_ids,
  trial_summaries,
  experiment_summaries,
}) {
  console.log("Analytics");

  var token;
  const [user, setUser] = React.useState("");

  // Builds a link to the Secure_Experiments Grafana dashboard
  const grafanaLink = (name, modelName, experimentId) => {
    const params = new URLSearchParams({
      orgId: "1",
      "var-model": modelName || "",
      "var-experiment_name": name || "",
      "var-experimentID": experimentId || "",
    });
    return `${window.location.origin}/grafana/d/adsngng/secure_experiments?${params.toString()}`;
  };

  return (
    <div>
      <h1>Model: Experiment:</h1>
      <Accordion activeIndex={0}>
        <AccordionTab header="Summary">
          <div style={{ display: "flex" }}>
            <BarPlot
              title="Experiment Run Time"
              xAxis="Experiments"
              yAxis="Time"
              x={experiment_summaries.run_time_avg}
              y={experiment_summaries.name}
              ori="h"
            />
            <BarPlot
              title="Trial Run Times"
              xAxis="Trials"
              yAxis="Times"
              y={trial_summaries.total_time}
              x={trial_summaries.x}
            />
          </div>
        </AccordionTab>
        <AccordionTab header="Grafana">
          {experiment_summaries.name.length === 0 ? (
            <p>No experiments to show yet.</p>
          ) : (
            <ul>
              {experiment_summaries.name.map((name, i) => (
                <li key={experiment_summaries._id?.[i] || i}>
                  <a
                    href={grafanaLink(
                      name,
                      experiment_summaries.model_name?.[i],
                      experiment_summaries._id?.[i],
                    )}
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    {name} in Grafana
                  </a>
                </li>
              ))}
            </ul>
          )}
        </AccordionTab>
      </Accordion>
    </div>
  );
}
